import React from "react";
import VideoContainer from "./VideoContainer";

const MainContainer = () => {
	return (
		<section className=" w-full h-full bg-slate-800 ">
			<VideoContainer />
		</section>
	);
};

export default MainContainer;
